// Port of yAxisTitle logic (chart.coffee:89-91) + yAxisLimits (chart.coffee:93-104).

import { round } from '@aytm/app/stats/lib/util/helpers'

import { CHART_VIEW_OPTIONS } from '@aytm/app/stats/page/question-views/ec/components/chart/lib/viewOptions'

export const getYAxisTitle = ({ viewMode, chartMode }) => {
  const base = CHART_VIEW_OPTIONS.find(o => o.value === viewMode)?.text || ''
  if (viewMode !== 'amount') return base
  return base + (['respondents', 'brespondents'].includes(chartMode) ? ' (respondents)' : ' (percents)')
}

export const getYAxisLimits = ({ viewMode, answerVariants, hcAnswers }) => {
  if (['amount', 'totalPickedUp', 'frequency'].includes(viewMode)) return null

  let min = 0
  let max = 0
  for (const av of answerVariants || []) {
    // hcAnswers[ak].amount is already a string (formatAmount returns string) — parseFloat OK,
    // but "" → NaN. Coffee has the same behavior (parseFloat amount).
    const raw = parseFloat(hcAnswers[`a${av.position}`]?.amount || 0)
    const amount = Number.isFinite(raw) ? raw : 0
    min = Math.min(min, amount)
    max = Math.max(max, amount)
  }

  min = min < 0 ? -Math.ceil(Math.abs(min)) : 0
  if (max <= 0 && min >= 0) max = 100
  else if (max <= 0) max = Math.ceil(Math.abs(min))
  else max = Math.ceil(max)

  return min === max ? null : [round(min, 2), round(max, 2)]
}
